// Module
var code = "<wt-generic-select model=\"vm.model\" items=\"vm.conditions\" name=\"{{vm.name}}\" isDisabled=\"vm.isDisabled\"> </wt-generic-select>";
// Exports
module.exports = code;